import initialState from './initialState';

const statsReducer = (state = initialState.stats, action) => {
    switch (action.type) {
        case 'STATS_SUCCESS':
            return action.stats;

        default:
            return state;
    }
};

export default statsReducer;
